module.exports = __webpack_public_path__ + "material-design.230faa5f470ef41a94f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design/material-design.svg?v=2.2.0
// module id = 692
// module chunks = 3